<template>
  <section>
    <section-header :title="section.title" />
    <div class="em-card-container">
      <a
        v-for="card in section.data"
        :key="`em-card-${card.origin}-${card.destination}`"
        class="em-card"
        :href="card.url"
        target="_blank"
      >
        <div class="left-side" :class="{'no-image': !card.destination_code}">
          <div v-if="card.destination_code" class="image">
            <v-lazy-image
              :src="`https://www.airbaltic.com/destinations-silo-2019/${card.destination_code.toLowerCase()}.jpg`"
              :alt="card.destination_code"
              width="56"
              height="56"
            />
          </div>
          <div class="title">{{ card.origin }} - {{ card.destination }}</div>
        </div>
        <span class="right-side" />
      </a>
    </div>
  </section>
</template>

<script>
  const SectionHeader = () =>
    import(
      /* webpackChunkName: "index-section-header" */ 'containers/Pages/IndexPage/SectionHeader'
    )
  import VLazyImage from 'v-lazy-image'

  export default {
    name: 'EveryMundoCards',
    components: {
      SectionHeader,
      VLazyImage
    },
    props: {
      section: {
        type: Object,
        required: true
      }
    }
  }
</script>

<style
  lang="scss"
  rel="stylesheet/scss"
  scoped
>
  @import '~assets/styles/common.scss';

  $border-radius: 6px;

  .em-card-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    .em-card {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex: 100%;
      background: white;
      border-radius: $border-radius;
      padding: rem(8, 16);
      cursor: pointer;
      text-decoration: none;

      @include bp-mf-tablet {
        flex: calc(50% - 20px);
      }

      @include bp-mf-desktop-large {
        flex: calc(calc(100% / 3) - 40px);
      }

      .left-side {
        display: flex;
        gap: rem(16, 16);
        align-items: center;

        &.no-image {
          padding-left: 15px;
        }

        .image {
          display: flex;
          border-radius: $border-radius;
          overflow: hidden;
        }

        .title {
          color: $blue-dark;
          font-size: rem(16, 16);
        }
      }

      .right-side {
        color: $blue-dark;
        padding: 5px;

        &:before {
          @include icon-font-thin();
          content: $icon-header-chevron;
          transform: rotate(270deg);
        }
      }
    }
  }
</style>
